import { Box, Button, Grid } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import UserSuscriptionsTable from "../../components/Table/Suscriptions/UserSuscriptionsTable";
import { Spinner } from "../../components/Loading/Spinner";

import { useSuperAdminSingleSuscrip } from "../../context/SuperAdmin/SingleSuscriptContext";
import SuscriptDescription from "../../components/Table/Suscriptions/SuscriptDescription";
import HeadersUserSuscription from "../../components/Table/Suscriptions/HeadersUserSuscription";
import TitleUserSuscription from "../../components/Table/Suscriptions/TitleUserSuscription";
import DeleteUserSuscriptModal from "../../components/Table/Suscriptions/DeleteUserSuscriptModal";
import AddUserSuscriptModal from "../../components/Table/Suscriptions/AddUserSuscriptModal";

const SingleSuscriptPage = () => {
  const { isLoadingSuscr } = useSuperAdminSingleSuscrip();
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button onClick={() => navigate(-1)} sx={{ color: "#336B87" }}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {isLoadingSuscr ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <TitleUserSuscription />
          </Grid>

          {/* Características del plan */}
          <Grid item>
            <SuscriptDescription />
          </Grid>

          {/* Linea divisoria */}
          <Grid item>
            <Box
              sx={{ height: "1px", width: 1, border: "1px solid #005559" }}
            ></Box>
          </Grid>

          {/* Agregar o eliminar usuarios */}
          <Grid item>
            <HeadersUserSuscription />
          </Grid>

          {/* Tabla de usuarios suscritos */}
          <Grid item>
            <UserSuscriptionsTable />
          </Grid>

          {/* Modal para agregar usuarios a la suscripcion */}
          <Grid item>
            <AddUserSuscriptModal />
          </Grid>

          {/* Modal para confirmar eliminar usuarios de la suscripcion */}
          <Grid item>
            <DeleteUserSuscriptModal />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SingleSuscriptPage;
